/* "More <brand> colours" on paint product pages (snippets/wl-table-products.liquid).
 * Nothing loads with the page. When the block nears the screen: the brand's in-stock paints (collection view
 * wlpp-more, compact JSON) and the paint picker's stylesheet, then the closest shades to this paint (OKLab distance,
 * as the picker measures colour), of the same kind (marker, spray or bottle): six in a row, four (two by two) on phones. The rest of the brand is one press away
 * in the Paint Picker, opened on this brand. Adds go straight to the basket, one per press. */
(function () {
  const root = document.getElementById('wlpm');
  if (!root || root.dataset.started) return;
  root.dataset.started = '1';
  const d = root.dataset;
  const ROUTE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const NEAR = 6;
  const $ = id => document.getElementById(id);

  /* ---------- Colour: trimmed from the paint picker's ColourEngine (assets/wl-paint-picker.js) ---------- */
  function normaliseHex(value) {
    const s = typeof value === 'string' ? value.trim() : '';
    if (/^#[\da-f]{6}$/i.test(s)) return s.toLowerCase();
    if (/^#[\da-f]{3}$/i.test(s)) return '#' + [...s.slice(1)].map(c => c + c).join('').toLowerCase();
    return null;
  }
  function toOklab(hex) {
    const [r, g, b] = hex.slice(1).match(/../g).map(s => { const n = parseInt(s, 16) / 255; return n <= .04045 ? n / 12.92 : ((n + .055) / 1.055) ** 2.4; });
    const l = Math.cbrt(.4122214708 * r + .5363325363 * g + .0514459929 * b);
    const m = Math.cbrt(.2119034982 * r + .6806995451 * g + .1073969566 * b);
    const s = Math.cbrt(.0883024619 * r + .2817188376 * g + .6299787005 * b);
    const L = .2104542553 * l + .793617785 * m - .0040720468 * s;
    const a = 1.9779984951 * l - 2.428592205 * m + .4505937099 * s;
    const B = .0259040371 * l + .7827717662 * m - .808675766 * s;
    return { L, a, b: B, C: Math.hypot(a, B), h: (Math.atan2(B, a) * 180 / Math.PI + 360) % 360 };
  }
  // The picker's colour family: only whether a paint is metallic or clear is used here.
  function family(c, name, range, finish) {
    if (/\b(clear|varnish|thinner|cleaner)\b/i.test(name + ' ' + range) || /\bmediums?$/i.test(name + ' ' + range)) return 'Clear';
    if (/metallic|metal colou?r/i.test(finish + ' ' + range) || /\bmetallic\b/i.test(name) || /^(?:(?:bright|dark|polished|burnt|old|antique|oily|flat|gloss)\s+)*(?:gold|silver|copper|brass|bronze|steel|aluminium|aluminum|gun\s?metal)$/i.test(name)) return 'Metallic';
    if (!c) return '';
    const { L, C, h } = c;
    if (C <= .025 && L < .23) return 'Black';
    if (C <= .022 && L > .955) return 'White';
    if (C <= .035) return 'Grey';
    if (h >= 35 && h < 110) { if (L >= .65 && C < .11) return 'Beige'; if (L < .67 && C < .16) return 'Brown'; }
    if (h >= 90 && h < 145 && C < .13 && L < .76) return 'Olive';
    if (h >= 285 && h < 335) return 'Purple';
    if (h >= 195 && h < 285) return 'Blue';
    if (h >= 115 && h < 195) return 'Green';
    if (h >= 75 && h < 115) return 'Yellow';
    if (h >= 35 && h < 75) return 'Orange';
    if (h >= 335 || h < 12) return L > .6 ? 'Pink' : 'Red';
    return L > .75 && C < .13 ? 'Pink' : 'Red';
  }
  const distance = (x, y) => Math.hypot(x.L - y.L, x.a - y.a, x.b - y.b);
  // Marker pens, spray cans or bottles: a marker page suggests markers, never bottles of paint.
  const kindOf = (type, box) => /marker/i.test(type + ' ' + box) ? 'marker' : /spray|aerosol/i.test(type + ' ' + box) ? 'spray' : 'bottle';

  /* ---------- Cards: the paint picker's markup and classes ---------- */
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = pence => '£' + (pence / 100).toFixed(2);
  const BASKET_PATH = 'M 4 7 C 3.449219 7 3 7.449219 3 8 C 3 8.550781 3.449219 9 4 9 L 6.21875 9 L 8.84375 19.5 C 9.066406 20.390625 9.863281 21 10.78125 21 L 23.25 21 C 24.152344 21 24.917969 20.402344 25.15625 19.53125 L 27.75 10 L 25.65625 10 L 23.25 19 L 10.78125 19 L 8.15625 8.5 C 7.933594 7.609375 7.136719 7 6.21875 7 Z M 22 21 C 20.355469 21 19 22.355469 19 24 C 19 25.644531 20.355469 27 22 27 C 23.644531 27 25 25.644531 25 24 C 25 22.355469 23.644531 21 22 21 Z M 13 21 C 11.355469 21 10 22.355469 10 24 C 10 25.644531 11.355469 27 13 27 C 14.644531 27 16 25.644531 16 24 C 16 22.355469 14.644531 21 13 21 Z M 16 7 L 16 10 L 13 10 L 13 12 L 16 12 L 16 15 L 18 15 L 18 12 L 21 12 L 21 10 L 18 10 L 18 7 Z M 13 23 C 13.5625 23 14 23.4375 14 24 C 14 24.5625 13.5625 25 13 25 C 12.4375 25 12 24.5625 12 24 C 12 23.4375 12.4375 23 13 23 Z M 22 23 C 22.5625 23 23 23.4375 23 24 C 23 24.5625 22.5625 25 22 25 C 21.4375 25 21 24.5625 21 24 C 21 23.4375 21.4375 23 22 23 Z';
  const basketSvg = `<svg viewBox="0 0 32 32" aria-hidden="true"><path d="${BASKET_PATH}"/></svg>`;
  const label = p => `${d.brand} ${p.code} ${p.name}`.replace(/\s+/g, ' ').trim();

  const inBasket = new Map(), busy = new Map();
  let byId = new Map();
  function basketButton(p) {
    const n = inBasket.get(p.id) || 0;
    return `<button type="button" class="wlpp-basket${n ? ' wlpp-basket--added' : ''}${busy.get(p.id) ? ' wlpp-basket--busy' : ''}" data-add="${p.id}" title="Add to basket" aria-label="Add ${esc(label(p))} to basket${n ? ', ' + n + ' in basket' : ''}"><span class="wlpp-basket-art wlpp-basket-art--normal">${basketSvg}</span><span class="wlpp-basket-art wlpp-basket-art--hover">${basketSvg}</span>${n ? `<span class="wlpp-basket-count" aria-hidden="true">${n}</span>` : ''}</button>`;
  }
  function card(p) {
    return `<article class="wlpp-card" style="--sw:${p.hex}"><a class="wlpp-swatch" href="${esc(p.url)}" aria-label="View ${esc(label(p))}"></a><div class="wlpp-body"><div class="wlpp-meta"><span title="${esc(p.range)}">${esc(p.range)}</span><b>${esc(p.code)}</b></div><a class="wlpp-name" href="${esc(p.url)}" title="${esc(p.name)}">${esc(p.name)}</a><div class="wlpp-foot"><span class="wlpp-price">${money(p.price)}</span><span class="wlpp-buy" data-buy="${p.id}">${basketButton(p)}</span></div></div></article>`;
  }
  const refreshButtons = id => root.querySelectorAll(`[data-buy="${id}"]`).forEach(el => { el.innerHTML = basketButton(byId.get(id)); });
  const say = html => { $('wlpm-status').innerHTML = html; };

  /* ---------- Load ---------- */
  function loadCss() {
    return Promise.all(d.css.split(' ').filter(Boolean).map(href => new Promise(done => {
      if (document.querySelector(`link[href="${href}"]`)) return done();
      const l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href; l.onload = l.onerror = done;
      document.head.appendChild(l);
    })));
  }
  const getPage = n => fetch(d.src + (n > 1 ? '&page=' + n : ''), { credentials: 'same-origin' }).then(r => { if (!r.ok) throw new Error(r.status); return r.json(); });
  async function loadPaints() {
    const first = await getPage(1);
    const rest = await Promise.all(Array.from({ length: Math.max(0, first.pages - 1) }, (_, i) => getPage(i + 2)));
    return [first, ...rest].flatMap(x => x.items);
  }
  function loadBasket() {
    return fetch(ROUTE + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(r => r.json()).then(c => {
      for (const it of c.items || []) inBasket.set(String(it.variant_id), (inBasket.get(String(it.variant_id)) || 0) + it.quantity);
    }).catch(() => {});
  }

  async function start() {
    let rows;
    try { [rows] = await Promise.all([loadPaints(), loadCss(), loadBasket()]); }
    catch (e) {
      root.classList.add('is-ready');
      say(`The ${esc(d.brand)} colours could not be loaded. <a href="${esc(root.querySelector('.wlpm-open').href)}">See them in the Paint Picker</a>.`);
      return;
    }
    const paints = rows.map(r => {
      const hex = normaliseHex(r.h);
      const lab = hex ? toOklab(hex) : null, fam = family(lab, r.c || '', r.r || '', r.f || '');
      return { kind: kindOf(r.t || '', r.k || ''), id: String(r.v), url: r.u, code: r.n || '', name: r.c || '', range: r.r || '', price: r.p, hex: hex || '#b5b8b9', lab, effect: fam === 'Metallic' || fam === 'Clear' ? fam : '' };
    });
    byId = new Map(paints.map(p => [p.id, p]));

    const here = normaliseHex(d.hex), hereLab = here && toOklab(here);
    const fam = family(hereLab, d.name, d.range, d.finish);

    // Closest shades: first the close ones of the same kind (metallics for a metallic, clears for a clear, ordinary
    // paints otherwise; a flat grey is no swap for an aluminium), then the nearest of any kind. A distant metallic
    // (Metal Purple for an aluminium) never takes a place from a near grey.
    const effect = fam === 'Metallic' || fam === 'Clear' ? fam : '';
    const kind = kindOf(d.type, d.box), others = paints.filter(p => p.lab && p.id !== d.self);
    const sameKind = others.filter(p => p.kind === kind);
    const byDistance = (sameKind.length >= 4 ? sameKind : others).map(p => [p, distance(p.lab, hereLab)]).sort((x, y) => x[1] - y[1]);
    const first = byDistance.filter(([p, dE]) => p.effect === effect && dE < .065).map(x => x[0]);
    const near = [...new Set([...first, ...byDistance.map(x => x[0])])].slice(0, NEAR);
    $('wlpm-near').innerHTML = near.map(card).join('');
    root.classList.add('is-ready');
  }

  /* ---------- Basket: one per press, one request at a time ---------- */
  let queue = Promise.resolve();
  function add(id) {
    const p = byId.get(id); if (!p) return;
    inBasket.set(id, (inBasket.get(id) || 0) + 1);
    busy.set(id, (busy.get(id) || 0) + 1);
    refreshButtons(id);
    root.querySelectorAll(`[data-add="${id}"]`).forEach(b => { b.classList.remove('wlpp-basket--pulse'); void b.offsetWidth; b.classList.add('wlpp-basket--pulse'); });
    queue = queue.then(async () => {
      try {
        const res = await fetch(ROUTE + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) });
        let data = null; try { data = await res.json(); } catch (e) {}
        if (!res.ok || (data && data.status && Number(data.status) >= 400)) throw new Error((data && (data.description || data.message)) || 'That paint could not be added to your basket.');
        refreshThemeCart(data && data.sections);
        say(`${esc(label(p))}: ${inBasket.get(id)} in your basket.`);
      } catch (e) {
        inBasket.set(id, Math.max(0, inBasket.get(id) - 1));
        say(esc(e.message));
      } finally {
        busy.set(id, busy.get(id) - 1);
        refreshButtons(id);
      }
    });
  }
  // Header count and slide-out basket contents, without opening the slide-out basket.
  function refreshThemeCart(sections) {
    if (!sections) return;
    const parse = html => new DOMParser().parseFromString(html, 'text/html');
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const fresh = parse(sections['cart-icon-bubble']).querySelector('#cart-icon-bubble');
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer && document.getElementById('CartDrawer');
    if (inner && sections['cart-drawer']) {
      const fresh = parse(sections['cart-drawer']).querySelector('#CartDrawer');
      if (fresh) { inner.innerHTML = fresh.innerHTML; drawer.classList.remove('is-empty'); }
    }
  }
  root.addEventListener('click', e => {
    const b = e.target.closest('[data-add]');
    if (b) { e.preventDefault(); add(b.dataset.add); }
  });

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => { if (entries.some(x => x.isIntersecting)) { io.disconnect(); start(); } }, { rootMargin: '300px 0px' });
    io.observe(root);
  } else start();
})();
